<template>
  <div>
    <div class="dropdown-container" v-if="dropDownCategories.length">
      <p class="label">{{ $t('addons.chooseSubcategory') }}</p>
      <v-select class="select-dropdown"
                v-model="selectedCategory"
                :options="dropDownCategories"
                :filterable="false"
                :searchable="false"></v-select>
    </div>
    <base-heading v-if="$props.listType === 'mobile'" :underline="false">{{ $t('addons.mobileAddonsTitle') }}</base-heading>
    <base-heading v-else :underline="false">{{ $t('addons.tvAddonsTitle') }}</base-heading>
    <div class="addon-list">
      <addon-card v-for="(addon, index) in displayedAddons[0].availableAddons"
                  :key="addon.name+index"
                  :addon-title="addon.name"
                  :addon-description="addon.description"
                  :addon-price="addon.price ? addon.price.formattedValue : null"
                  :addon-features="addon.specCharacteristicValues"
                  :button-text="$t('common.activate')"
                  :cardType="$props.listType"
                  :has-channels="!!addon.code"
                  @view-channels="emitViewChannels(addon)"
                  @button-click="openActivationModal(addon.name, addon.externalId)"/>

    </div>
    <template v-if="$props.listType === 'mobile'">
      <active-addons-table v-if="displayedAddons[0].activatedAddons && displayedAddons[0].activatedAddons.length"
                           :active-addons="displayedAddons[0].activatedAddons"
                           @deactivate-addon="openDeactivateModal"/>
      <div v-else :key="'no-addons'">
        <base-heading :underline="false" class="addon-heading">{{ $t('overviewAddons.addonsTitle') }}</base-heading>
        <h3 class="title">{{ $t('addons.noActivatedAddons') }}</h3>
      </div>
    </template>
    <template v-else>
      <base-heading :underline="false" class="addon-heading">{{ $t('overviewAddons.addonsTitle') }}</base-heading>
      <template v-if="displayedAddons[0].activatedAddons && displayedAddons[0].activatedAddons.length">
        <div class="addon-list">
          <addon-card v-for="(addon, index) in displayedAddons[0].activatedAddons"
                      :key="addon.name+index"
                      :addon-title="addon.name"
                      :addon-description="addon.description"
                      :addon-price="addon.price ? addon.price.formattedValue : null"
                      :addon-features="addon.specCharacteristicValues"
                      :button-text="$t('common.deactivate')"
                      :cardType="$props.listType"
                      :recurring="addon.recurring"
                      active-addon-card
                      :has-channels="!!addon.code"
                      @view-channels="emitViewChannels(addon)"
                      @button-click="openDeactivateModal(addon.name, addon.externalId)"/>
        </div>
      </template>
        <div v-else :key="'no-addons'">
          <h3 class="title">{{ $t('addons.noActivatedAddons') }}</h3>
        </div>
    </template>
    <confirmation-modal :visible="addonsActivationModal"
                        :loading="$props.confirmationLoader"
                        @close="addonsActivationModal = false"
                        :closeButtonVisible="false"
                        confirm-type="empty"
                        :cancel-button="true"
                        :dynamic-confirm-title="$t('addons.activationModalDescription',{ addonName: addonName } )"
                        :confirm-description="$t('addons.confirmationModalAddonsDescription')"
                        :confirm-text="$t('common.activate')"
                        :button-disabled="buttonDisabled"
                        @confirm="emitActivateAddonsApi"
    />
    <confirmation-modal :visible="addonsDeactivateModal"
                        :loading="$props.confirmationLoader"
                        :closeButtonVisible="false"
                        :cancel-button="true"
                        @close="addonsDeactivateModal = false"
                        confirm-type="empty"
                        :dynamic-confirm-title="$t('addons.deactivationModalDescription',{ addonName: activatedName } )"
                        :confirm-description="$t('addons.confirmationModalAddonsDescription')"
                        :confirm-text="$t('common.deactivate')"
                        :button-disabled="buttonDisabled"
                        @confirm="emitDeactivateAddons"
    />
  </div>
</template>

<script>
import AddonCard from '@/components/addons/addon-card'
import ActiveAddonsTable from '@/components/addons/active-addons-table'
import ConfirmationModal from '@/components/common/modal/confirmation-modal'

export default {
  name: 'addon-list',
  components: { ActiveAddonsTable, AddonCard, ConfirmationModal },
  props: {
    addonData: {
      type: Array,
      default: () => []
    },
    listType: {
      type: String,
      default: 'mobile',
      validator: value => {
        const availableTypes = ['mobile', 'tv']
        return availableTypes.includes(value)
      }
    },
    confirmationLoader: {
      type: Boolean
    }
  },
  data () {
    return {
      addonsDeactivateModal: false,
      addonsActivationModal: false,
      dropDownCategories: [],
      selectedCategory: '',
      displayedAddons: [],
      addonName: '',
      externalId: '',
      activatedName: '',
      activatedExternalId: '',
      buttonDisabled: false
    }
  },
  methods: {
    openActivationModal (addonName, externalId) {
      this.addonsActivationModal = true
      this.addonName = addonName
      this.externalId = externalId
    },
    openDeactivateModal (activatedName, activatedExternalId) {
      this.addonsDeactivateModal = true
      this.activatedName = activatedName
      this.activatedExternalId = activatedExternalId
    },
    emitActivateAddonsApi () {
      this.buttonDisabled = true
      this.$emit('confirm-activation', this.externalId)
    },
    emitDeactivateAddons () {
      this.buttonDisabled = true
      this.$emit('confirm-deactivation', this.activatedExternalId)
    },
    filterDropDownCategories (data) {
      const categories = data.filter(addon => addon.categories)
      const filteredList = categories.map(category => {
        return category.categories.map(cat => cat.name)
      })

      this.dropDownCategories = filteredList[0] || []
      if (this.dropDownCategories.length) {
        this.selectedCategory = this.dropDownCategories[0]
      }
    },
    filterDisplayedAddons (data) {
      data.filter(addons => {
        if (addons.categories) {
          this.displayedAddons = addons.categories.filter(category => category.name === this.selectedCategory)
        } else {
          this.displayedAddons = [addons]
        }
      })
    },
    emitViewChannels (data) {
      const dataToSend = {
        code: data.code,
        channelsAmount: data.channelsAmount,
        name: data.name
      }

      this.$emit('view-channels', dataToSend)
    }
  },
  watch: {
    '$props.addonData': {
      handler (newVal) {
        this.filterDropDownCategories(newVal)
        this.filterDisplayedAddons(newVal)
      },
      immediate: true
    },
    selectedCategory: {
      handler (newVal) {
        if (newVal) {
          this.filterDisplayedAddons(this.$props.addonData)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.addon-list {
  display: flex;
  flex-wrap: wrap;
  width: calc(100% + 4rem);
  max-width: calc(100% + 4rem);
  margin: 0 -2rem;

  .addon-card {
    flex-basis: 100%;
    width: 100%;

    @media (map_get($breakpoints, exsm)) {
      margin: 0 1rem 2rem;
      flex-basis: calc(50% - 2rem);
      max-width: calc(50% - 2rem);
    }

    @media (map_get($breakpoints, sm)) {
      margin: 0 2rem 4rem;
      flex-basis: calc(50% - 4rem);
      max-width: calc(50% - 4rem);
    }

    @media (map_get($breakpoints, lg)) {
      flex-basis: calc(33.3334% - 4rem);
      max-width: calc(33.3334% - 4rem);
    }

    @media (map_get($breakpoints, xxl)) {
      flex-basis: calc(25% - 4rem);
      max-width: calc(25% - 4rem);
    }
  }
}

.dropdown-container {
  margin-bottom: 4rem;

  .label {
    font-size: 1.2rem;
    color: $dark-grey;
    margin-bottom: 0.8rem;
  }

  .select-dropdown {
    width: 100%;

    @media (map_get($breakpoints, exsm)) {
      max-width: 285px;
    }
  }
}
</style>
